import React, { useEffect } from 'react';

export function ClearCache() {
  useEffect(() => {
    async function clearCacheAndReload() {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
          await registration.unregister();
        }
      }
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      window.location.reload();
    }
    clearCacheAndReload();
  }, []);

  return null;
}
